// extracted by mini-css-extract-plugin
export default {"score":"score_kl0Nc","detailContainer":"detailContainer_kvnzz","patientDetailTabs":"patientDetailTabs_HPZ2x","btn":"btn_Ys4C7"};